import { KeyResult } from "@/types";
import { summarizeKrWeights } from "./kr-weight-summary";

interface KrWeightSummaryProps {
    keyResults: KeyResult[];
}

/** Explains how objective progress rolls up from its KRs' weights. */
export function KrWeightSummary({ keyResults }: KrWeightSummaryProps) {
    if (keyResults.length === 0) return null;
    const { total, weighted, unweighted, count } = summarizeKrWeights(keyResults);
    const krLabel = count === 1 ? "KR" : "KRs";

    if (weighted === 0) {
        return (
            <p className="text-xs text-muted-foreground mt-1">
                Equal split across {count} {krLabel} (no weights set)
            </p>
        );
    }

    const parts = keyResults
        .filter(kr => (kr.weight ?? 0) > 0)
        .map(kr => Math.round(kr.weight ?? 0))
        .join(" + ");

    return (
        <div className="mt-1">
            <p className="text-xs text-muted-foreground">
                Weights {parts} = {Math.round(total)} across {count} {krLabel}
                {Math.round(total) !== 100 && " · normalized to 100"}
            </p>
            {unweighted > 0 && (
                <p className="text-xs text-amber-600 dark:text-amber-500 mt-0.5">
                    {unweighted} unweighted {unweighted === 1 ? "KR" : "KRs"} contribute{unweighted === 1 ? "s" : ""} 0
                </p>
            )}
        </div>
    );
}
